import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=6eb79aac&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb79aac",
  null
  
)

export default component.exports